<template>
  <a-drawer
    class="lin-drawer"
    :body-style="bodyStyle"
    @close="onClose"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:title>
      <slot name="title">
        {{ title }}
      </slot>
    </template>

    <LocaleProviderZh>
      <a-spin :spinning="loading">
        <slot></slot>
      </a-spin>
    </LocaleProviderZh>

    <template v-for="(item, key) in $slots" v-slot:[key]="slotScope">
      <slot :name="key" v-bind="slotScope"></slot>
    </template>

    <div class="lin-drawer__footer" v-show="isShowFooter">
      <div></div>
      <div style="padding-right: 16px;">
        <slot name="footer-right">
          <a-button style="margin-right: 16px;" @click="$emit('cancel')">{{
            cancelText
          }}</a-button>
          <a-button
            type="primary"
            :loading="confirmLoading"
            @click="$emit('ok')"
            >{{ okText }}</a-button
          >
        </slot>
      </div>
    </div>
  </a-drawer>
</template>

<script>
export default {
  name: "LinDrawer",

  inheritAttrs: false,

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    bodyStyle: {
      default: () => ({ paddingBottom: "60px" }),
    },
    isShowFooter: {
      type: Boolean,
      default: true,
    },
    okText: {
      default: "确定",
    },
    cancelText: {
      default: "取消",
    },
    confirmLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onClose() {
      this.$emit("close");
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.lin-drawer {
  ::v-deep .ant-drawer-header {
    position: sticky;
    top: 0;
    z-index: 100;
  }
}

.lin-drawer__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 2;
  border-top: 1px solid #e4e5e7;
  background: #ffffff;
}
</style>
